import { Card, Divider, CardContent, Grid, Skeleton, Toolbar, CardActions, Button } from '@mui/material'
import Header from 'components/Header'
import { useTranslation } from 'react-i18next'

export default function AcademicYearProviderEditFormSkeleton() {
  const { t } = useTranslation()
  return (
    <Card component="form" noValidate sx={{ minHeight: '100%' }}>
      <Toolbar />
      <Header title={t('Marking Periods')} close small />
      <CardContent>
        <Divider />
        <Grid container spacing={2} sx={{ my: 1 }}>
          <Grid container>
            <Grid item xs={9}></Grid>
            <Grid item xs={3} sx={{ my: 0 }}>
              <Skeleton height={60} />
            </Grid>
          </Grid>
          <Grid item sm={12} xs={12}>
            <Skeleton height={250} />
          </Grid>
        </Grid>
        <Grid item sm={12} xs={12}>
          <Skeleton height={250} />
        </Grid>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button variant="outlined">
          <Skeleton />
        </Button>
        <Button type="submit" variant="contained">
          <Skeleton />
        </Button>
      </CardActions>
    </Card>
  )
}
